import { ExportOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
import { Button } from 'antd';
import React, { useState } from 'react';
import { EXPORT_TYPES, MODULES } from '../../../../../common/constants';
import Portal from '../../../../../components/Portal';
import NewTabs from '../components/NewTabs';
import RiderManagementTable from '../components/RiderManagementTable';
import { REQUEST_NEW_ORDER_EXPORT } from '../graphql/Mutations';

const AssignDeliveryPartner = () => {
  const [exportFilter, setExportFilter] = useState();
  const [isExportLoading, setIsExportLoading] = useState(false);

  const [requestOrderExport] = useMutation(REQUEST_NEW_ORDER_EXPORT, {
    onError: () => {},
  });

  const handleExport = async () => {
    setIsExportLoading(true);
    await requestOrderExport({
      variables: {
        data: {
          type: EXPORT_TYPES?.NEW_ORDERS,
        },
        filter: {
          search: exportFilter?.search,
          deliveryType: exportFilter?.deliveryType,
          orderIds: exportFilter?.orderNumber,
          dateRange: {
            from: exportFilter?.createdAt?.from?.$d,
            to: exportFilter?.createdAt?.to?.$d,
          },
          pincodeIds: exportFilter?.pincodes,
        },
      },
    });
    setIsExportLoading(false);
  };

  return (
    <>
      <Portal portalId="header-title-content">
        <div className="portal-header">{MODULES?.ASSIGN_DELIVERY_PARTNER}</div>
      </Portal>
      <Portal portalId="header-right-content">
        <Button
          className="common-button ml-16"
          size="middle"
          icon={<ExportOutlined />}
          onClick={handleExport}
          loading={isExportLoading}
        >
          Export
        </Button>
      </Portal>
      <Portal portalId="header-right-content-phones">
        <Button
          className="common-button ml-16"
          size="middle"
          icon={<ExportOutlined />}
          onClick={handleExport}
          loading={isExportLoading}
        >
          Export
        </Button>
      </Portal>
      <div className="tab-table">
        <NewTabs>
          <RiderManagementTable
            exportFilter={exportFilter}
            setExportFilter={setExportFilter}
          />
        </NewTabs>
      </div>
    </>
  );
};

export default AssignDeliveryPartner;
